import { useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  CarePlanGoalResponse,
  CarePlanProblemResponse,
  CarePlanResponse,
} from '~/lib/types/carePlan/carePlans';
import { AddCustomInterventionModal } from './AddCustomInterventionModal';
import { CarePlanGoalsSection } from './CarePlanGoalsSection';

type Props = {
  problems: CarePlanProblemResponse[];
  treatmentEpisodeId: string;
  carePlan: CarePlanResponse;
  onEditProblemClick: (problem: CarePlanProblemResponse) => void;
  onEditGoalClick: (goal: CarePlanGoalResponse) => void;
  onRemoveGoalClick: (problemId: string) => void;
};

export const ActiveCarePlanTreatmentGoalsSection = ({
  problems,
  treatmentEpisodeId,
  carePlan,
  onEditProblemClick,
  onEditGoalClick,
  onRemoveGoalClick,
}: Props) => {
  const { carePlanM4CustomInterventions } = useFlags<LDFlags>();
  const [preselectedGoalId, setPreselectedGoalId] = useState<string | null>(
    null,
  );

  return (
    <>
      <CarePlanGoalsSection
        sectionId="treatment-goals-section"
        sectionTitle="Treatment goals"
        problems={problems}
        treatmentEpisodeId={treatmentEpisodeId}
        carePlanId={carePlan.id}
        onEditProblemClick={onEditProblemClick}
        onEditGoalClick={onEditGoalClick}
        onAddInterventionClick={
          carePlanM4CustomInterventions
            ? (goal) => setPreselectedGoalId(goal.id)
            : undefined
        }
        onRemoveGoalClick={onRemoveGoalClick}
      />
      {preselectedGoalId && (
        <AddCustomInterventionModal
          carePlan={carePlan}
          onClose={() => setPreselectedGoalId(null)}
          preselectedGoalId={preselectedGoalId}
          treatmentEpisodeId={treatmentEpisodeId}
        />
      )}
    </>
  );
};
